import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=528faffa&scoped=true&"
import script from "./Mask.vue?vue&type=script&lang=js&"
export * from "./Mask.vue?vue&type=script&lang=js&"
import style0 from "./Mask.vue?vue&type=style&index=0&id=528faffa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528faffa",
  null
  
)

export default component.exports